module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-2.4edfd74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-2.jpg
// module id = 3x7T
// module chunks = 1